import React from 'react';
import { autobind } from 'core-decorators';
import List from '../../../componentes/list';
import ListColumn from '../../../componentes/list/list-column';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Funcao from './edit';
import { capitalizeFirstLetter } from '../../../utils/string';
import LucideIcon from 'src/componentes/lucide-icon';
import HistoricoColaboradorFuncao from './HistoricoColaboradorFuncao';

@autobind
class FuncaoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mostrarHistorico: false,
    };
  }

   handleToggleHistorico() {
    this.setState((prevState) => ({
      mostrarHistorico: !prevState.mostrarHistorico,
    }));
  }

  render() {
    let { model, intl, resources, disabled } = this.props;
    let podeEditar = !model.getModel('podeEditar').value;
    const { mostrarHistorico } = this.state;
    const colaboradorId = model.getModel('id').value;

    return (
      <div>
        <div>
          <List
            url="/ColaboradorFuncao"
            showSearch={false}
            titulo={capitalizeFirstLetter(resources.funcoes)}
            editComponent={Funcao}
            sort="dataInicio"
            parameters={{ ColaboradorId: model.getModel('id').value }}
            showExport={false}
            showNew={podeEditar}
            showDelete={podeEditar}
            disabled={disabled}
            podeEditar={podeEditar}
            {...this.props}
          >
            <ListColumn
              headerText={intl.formatMessage({ id: 'dataInicio' })}
              valueField="dataInicio"
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'dataTermino' })}
              valueField="dataTermino"
            />
            <ListColumn
              headerText={capitalizeFirstLetter(resources.funcao)}
              valueField="funcao"
            />
          </List>
        </div>
        <div className="mt-3">
          <a
            className="text-primary text-sm font-weight-bolder"
           onClick={this.handleToggleHistorico}
          >
            <LucideIcon
              className="mr-2"
              icon={`${mostrarHistorico ? 'eye-off-outline' : 'eye-outline'}`}
              size={20}
            />
            {mostrarHistorico
              ? intl.formatMessage({ id: 'ocultarHistorico' })
              : intl.formatMessage({ id: 'verHistorico' })}
          </a>
          {mostrarHistorico && (
            <HistoricoColaboradorFuncao
              colaboradorId={colaboradorId}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(FuncaoList));
